module.exports = __webpack_public_path__ + "img/pic8.d689c1b0.png";